<template>
  <LayoutDashboard title="Entradas de Mercadorias">
    <v-card outlined>
      <v-card-title>
        <v-btn
          color="primary"
          @click="cadastrarEntradaMercadoria"
          outlined
          v-if="$helper.verificaPermissao('cadastrar-entrada-mercadoria')"
          >Cadastrar</v-btn
        >
        <v-spacer></v-spacer>
        Registros: {{getEntradasMercadorias.total}} - 
        <v-pagination
          outlined
          total-visible="7"
          v-model="dataPagina.page"
          :length="getEntradasMercadorias.last_page"
          @input="(dataPagina.page = $event), debouncedListar()"
        ></v-pagination>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th width="8%">
                  <v-text-field
                    label="Cód"
                    v-model="dataPagina.id"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedListar()"
                  ></v-text-field>
                </th>
                <th>
                  <v-text-field
                    label="Fornecedor"
                    v-model="dataPagina.fornecedor"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedListar()"
                  ></v-text-field>
                </th>
                <th>
                  <v-text-field
                    label="Chave NF"
                    v-model="dataPagina.chave_nfe"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedListar()"
                  ></v-text-field>
                </th>
                <th width="8%">
                  <v-text-field
                    label="Nº Nota"
                    v-model="dataPagina.numero_nota"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedListar()"
                  ></v-text-field>
                </th>

                <th width="12%">Total</th>
                <th width="12%">
                  <v-select
                    :items="['Pendente', 'Finalizado']"
                    v-model="dataPagina.status"
                    label="Status"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedListar()"
                  ></v-select>
                </th>
                <th width="8%">
                  <v-text-field
                    label="Data Entrada"
                    v-model="dataPagina.data_entrada"
                    outlined
                    dense
                    class="mt-2"
                    type="date"
                    @input="debouncedListar()"
                  ></v-text-field>
                </th>
                <th width="8%">
                  <v-select
                    :items="[10, 20, 30, 40, 50]"
                    v-model="dataPagina.limit"
                    label="Exibir"
                    outlined
                    dense
                    class="mt-2"
                    @input="debouncedListar()"
                  ></v-select>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="i in getEntradasMercadorias.data" :key="i.id">
                <td>{{ i.id }}</td>
                <td colspan="2">{{ i.fornecedor ? i.fornecedor.nome : '' }} <br> {{ i.chave_nfe }}</td>
                <td>{{ i.numero_nota }}</td>
                <td>R$ {{ $helper.formatReal(parseFloat(i.total)) }}</td>
                <td>{{ i.status }}</td>
                <td>{{ $helper.formatDate(i.data_entrada) }}</td>
                <td>
                  <v-btn
                    color="primary"
                    outlined
                    small
                    @click="
                      $router.push({
                        name: 'entradaMercadoriaEditar',
                        params: { id: i.id },
                      })
                    "
                    v-if="
                      $helper.verificaPermissao('visualizar-entrada-mercadoria')
                    "
                    >Visualizar</v-btn
                  >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <h3> Registros: {{getEntradasMercadorias.total}} - </h3> 
        <v-pagination
          outlined
          :total-visible="6"
          v-model="dataPagina.page"
          :length="getEntradasMercadorias.last_page"
          @input="(dataPagina.page = $event), debouncedListar()"
        ></v-pagination>
      </v-card-actions>
    </v-card>
  </LayoutDashboard>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
var _ = require("lodash");
export default {
  data() {
    return {
      dataPagina: {
        id: "",
        chave_nfe: "",
        numero_nota: "",
        fornecedor: "",
        status: "",
        data_entrada: "",
        limit: 20,
        page: 1,
      },
    };
  },
  computed: {
    ...mapGetters(["getEntradaMercadoria", "getEntradasMercadorias"]),
  },
  methods: {
    ...mapActions(["listarEntradaMercadoria", "cadastrarEntradaMercadoria"]),

    listar() {
      this.listarEntradaMercadoria(this.dataPagina);
    },
  },
  created() {
    this.listar();
    this.debouncedListar = _.debounce(this.listar, 300);
  },
};
</script>